import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import {
  BaseButton,
  BaseButtonWrapper,
  ButtonLoadingSpinner,
  ButtonProps,
  IconWrapper,
} from './BaseButton';

export type StyledSecondaryButtonProps = {
  isActive: boolean;
};

const ActiveStyles = css`
  color: ${theme.colors.primary.white};
  background-color: ${theme.colors.tints.graysBlue['_2']};
  fill: ${theme.colors.primary.white};
`;

export const SecondaryStyles = css<StyledSecondaryButtonProps>`
  color: ${theme.colors.primary.graysBlue};
  background: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.primary.graysBlue};
  fill: ${theme.colors.primary.graysBlue};

  ${({ isActive }) => isActive && ActiveStyles};

  &:hover {
    color: ${theme.colors.primary.white};
    background-color: ${theme.colors.tints.graysBlue['_1']};
    fill: ${theme.colors.primary.white};
  }

  &:active {
    ${ActiveStyles};
  }
`;

const StyledSecondaryButton = styled(BaseButton)<StyledSecondaryButtonProps>`
  ${SecondaryStyles};
`;

export type SecondaryButtonProps = ButtonProps &
  Partial<StyledSecondaryButtonProps>;

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  disabled = false,
  isActive = false,
  fullWidth = false,
  isLoading = false,
  size = 'medium',
  iconLeft: IconLeft,
  iconRight: IconRight,
  iconFill = '',
  iconWidth = 16,
  children,
  ...props
}) => {
  const [isFocussed, setIsFocussed] = useState(false);

  useEffect(() => {
    if (disabled) setIsFocussed(false);
  }, [disabled]);

  return (
    <BaseButtonWrapper
      size={size}
      fullWidth={fullWidth}
      isFocussed={isFocussed}
    >
      <StyledSecondaryButton
        disabled={disabled}
        isActive={isActive}
        fullWidth={fullWidth}
        isLoading={isLoading}
        onTouchStart={() => setIsFocussed(true)}
        onFocus={() => setIsFocussed(true)}
        onMouseLeave={() => setIsFocussed(false)}
        size={size}
        {...props}
      >
        <IconWrapper>
          {IconLeft && <IconLeft fill={iconFill} width={iconWidth} />}
          {isLoading ? <ButtonLoadingSpinner size={size} /> : children}
          {IconRight && <IconRight fill={iconFill} width={iconWidth} />}
        </IconWrapper>
      </StyledSecondaryButton>
    </BaseButtonWrapper>
  );
};
